import {
  DashboardContentPlaceholder,
  DashboardCardContent,
  DashboardCardHeader,
  DashboardCard,
} from '@pages/dashboard/components';
import { useHasPermission, useCurrentUser } from '@shared/hooks';
import { CurrencyFormatted, Typography } from '@ui/components';
import { useGetDashboard } from '@pages/dashboard/hooks';
import { NavPayment } from '@ui/components/icons';
import { useTranslation } from 'react-i18next';
import { Routes } from '@shared/enums';
import React from 'react';

export const DashboardServicesSummary = (props: React.ComponentPropsWithoutRef<'div'>) => {
  const { t } = useTranslation();
  const { currency } = useCurrentUser();
  const { data, isLoading } = useGetDashboard();
  const hasPermission = useHasPermission('DASHBOARD_SERVICES_SEE_DETAILS', 'READ');

  return (
    <DashboardCard {...props}>
      <DashboardCardHeader
        link={{
          label: t('DASHBOARD.SERVICES.SEE_MORE'),
          href: `../${Routes.COST_CENTER}`,
        }}
        title={t('DASHBOARD.SERVICES.TITLE')}
        isLinkVisible={hasPermission}
        icon={<NavPayment />}
        className="mb-8"
      />

      <DashboardCardContent isLoading={isLoading}>
        {data && data.currentMonthSpendings > 0 ? (
          <>
            <Typography variant="labelMediumMedium" className="text-weak">
              {t('DASHBOARD.SERVICES.EXPENSES')}
            </Typography>
            <Typography variant="h500" asChild>
              <CurrencyFormatted value={data.currentMonthSpendings} currency={currency} />
            </Typography>
          </>
        ) : (
          <DashboardContentPlaceholder
            title={t('DASHBOARD.SERVICES.PLACEHOLDER_TITLE')}
            icon={<NavPayment />}
          />
        )}
      </DashboardCardContent>
    </DashboardCard>
  );
};
